import { createStore, combineReducers, applyMiddleware } from "redux";
import profileModalReducer from "./reducers/profileModalReducer";
import showAccountReducer from "./reducers/showAccountReducer";
import showBillingReducer from "./reducers/showBillingReducer";
import showInsightsReducer from "./reducers/showInsightsReducer";
import showTeamMembersReducer from "./reducers/showTeamMembersReducer";
import showCallScriptsReducer from "./reducers/showCallScriptsReducer";
import showVerificationsReducer from "./reducers/showVerificationsReducer";
import showPatientCallsReducer from "./reducers/showPatientCallsReducer";
import showRequestReducer from "./reducers/showRequestReducer";
import showNewRequestPageReducer from "./reducers/showNewRequestPageReducer";
import setInboxReducer from "./reducers/setInboxReducer";
import showAccountSavedReducer from "./reducers/showAccountSavedReducer";
import fetchRequestReducer from "./reducers/fetchRequestReducer";
import thunk from "redux-thunk";

const rootReducer = combineReducers({
  profileModal: profileModalReducer,
  showAccount: showAccountReducer,
  showBilling: showBillingReducer,
  showInsights: showInsightsReducer,
  showTeamMembers: showTeamMembersReducer,
  showCallScripts: showCallScriptsReducer,
  showVerifications: showVerificationsReducer,
  showPatientCalls: showPatientCallsReducer,
  showRequest: showRequestReducer,
  showNewRequestPage: showNewRequestPageReducer,
  showAccountSaved: showAccountSavedReducer,
  fetchRequest: fetchRequestReducer,
  setInbox: setInboxReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
